import { WindowPercentageArea } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const windowPercentageAreaToPhraseKeyDictionary: EnumDictionary<WindowPercentageArea, string> = {
    [WindowPercentageArea.Small]: 'HEATLOAD.WINDOWS_AND_GLAZING.SMALL',
    [WindowPercentageArea.Medium]: 'HEATLOAD.WINDOWS_AND_GLAZING.MEDIUM',
    [WindowPercentageArea.Large]: 'HEATLOAD.WINDOWS_AND_GLAZING.LARGE'
};
